import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class FixedIncomePrivateProvider extends HttpService {

    /**
     * Serviço de integração ao backend de renda fixa privada
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('fixedIncomePrivate', http, settingsService);
    }

}